import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import Api from "./Api";

import { assistencia24hApiConfig } from "./config";
import { PrestadorModel } from '@/models/cadastros/assistencia/PrestadorModel';
import { PrestadorDTO, TelefonesDTO, ServicosDTO, AgenteDTO, EnderecosDTO, ContatosDTO, ComissionamentosDTO, InformacoesDTO } from './CadastrosGeraisService';
import { estadosList } from '@/models/commons/EstadoModel';

import { CadastroPrecoDTO } from './assistencia24h/CadastroPrecoDTO';
import { FiltroPesquisaPrecoDTO } from "./assistencia24h/FiltroPesquisaPrecoDTO";

import { ServicoDetalhadoModel, FinalizarSolicitacaoModel } from "@/models/solicitacoes";

import ServicoPrestadorDTO from "./servico/ServicoPrestadorDTO";
import FiltroServicoDTO from "./servico/FiltroServicoDTO";

import FiltroServicoSemPrestadorDTO from "./servico/FiltroServicoSemPrestadorDTO";
import ResultadoServicosSemPrestadorDTO from "./servico/ResultadoServicosSemPrestadorDTO";

import ResultadoFiltroServicosDTO from "./servico/ResultadoFiltroServicosDTO";
import {PercentualServicoDTO} from "@/models/commons/ConfiguracaoModel";
import {BancoDTO} from "@/models/commons/BancoModel";
import { PrecosServicoModel } from "@/models/solicitacoes/PrecosServicoModel";

import {FaixaPercentualDTO} from "@/models/solicitacoes/FaixaPercentualServicosModel";
import {RelatorioLogPrecificacaoModel} from "@/models/administracao/log-precificacao/RelatorioLogPrecificacaoModel";
import {LogPrecificacaoModel} from "@/models/administracao/log-precificacao/LogPrecificacaoModel";

import {TermoDeUsoDTO} from "@/models/commons/TermoDeUsoModel";

import { SegmentoDTO } from "@/models/commons/SegmentoModel";
import { ClienteFrotaModel } from "@/models/cadastros/assistencia/ClienteFrotaModel";
import { ITelefoneModel } from "@/models/commons/TelefoneModel";
import FiltroLeadFrotaDTO from "@/api/integracao-contabil/FiltroLeadFrotaDTO"
import { FiltroAgenteModel } from "@/models/cadastros/assistencia/agente/FiltroAgenteModel";
import { AgenteModel } from "@/models/cadastros/assistencia/agente/AgenteModel";
import { SolicitacaoServicoDTO } from "./assistencia24h/SolicitacaoServicoDTO";
import { ConfirmacaoSolicitacaoDTO } from "@/api/assistencia24h/ConfirmacaoSolicitacaoDTO";
import { FiltroSolicitadoesDTO } from "@/api/assistencia24h/FiltroSolicitadoesDTO";
import { ResultadoConsultaSolicitacoesDTO } from "@/api/assistencia24h/ResultadoConsultaSolicitacoesDTO";
import { AvaliacaoServicoDTO } from "./assistencia24h/AvaliacaoServicoDTO";
import { ConfirmacaoSolicitacaoFrotaDTO } from "@/api/assistencia24h/ConfirmacaoSolicitacaoFrotaDTO";

// @ts-ignore
import _ from 'lodash';

class Assistencia24hApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  pesquisarPrecos(filtro: FiltroPesquisaPrecoDTO): Promise<any> {
    return this.get("/preco/associado", { params: filtro });
  }

  salvarPreco(preco: CadastroPrecoDTO): Promise<any> {
    return this.post<any>("/preco/associado", preco);
  }

  atualizarPreco(idPreco: number, preco: CadastroPrecoDTO): Promise<any> {
    return this.put<any>(`/preco/associado/${idPreco}`, preco);
  }
  
  obterPrecoPorId(idPreco: Number): Promise<any> {
    return this.get(`/preco/associado/${idPreco}`);
  }

  deletarPreco(idPreco: Number): Promise<any> {
    return this.delete(`/preco/associado/${idPreco}`)
  }
  
  savePrestadorAssistencia(prestador: PrestadorModel): Promise<any> {

    let prestadorDTO: PrestadorDTO = {
      cpfCnpj: prestador.cpfCnpj?.replace(/\D/g,""),
      tipoPessoa: prestador.tipoPessoaString == "F" ? "FISICA" : "JURIDICA",
      nome: prestador.nomeRazaoSocial,
      flagPrestadorCadastradoCPOM: prestador.flagCadastroCPOM,
      email: prestador.email,
      ativo: prestador.ativo,
      enderecos: [
        {
          cep: prestador.endereco?.cep,
          tipo: prestador.endereco?.tipo?.nome,
          logradouro: prestador.endereco?.logradouro,
          numero: prestador.endereco?.numero,
          complemento: prestador.endereco?.complemento,
          bairro: prestador.endereco?.bairro,
          cidade: prestador.endereco?.cidade,
          estado: prestador.endereco?.estado
            ? estadosList
                .map((e) => e.sigla)
                .filter((ec) => ec == prestador.endereco?.estado?.sigla)
                .toString()
            : "-1",
        },
      ],
      contaBancaria: 
        {
          codigoBanco: prestador.contaBancaria.codigoBanco,
          contaPrincipal: true,
          id: prestador.contaBancaria.id,
          cpfCnpjTitular: prestador.cpfCnpj?.replace(/\D/g,""),
          digitoConta: prestador.contaBancaria.digitoConta,
          nomeTitular: prestador.nomeRazaoSocial,
          numeroAgencia: prestador.contaBancaria.numeroAgencia,
          numeroConta: prestador.contaBancaria.numeroConta,
          digitoAgencia: prestador.contaBancaria.digitoAgencia,
          tipoContaBancaria: prestador.contaBancaria.tipoContaBancaria?.nomeIntegracao,
          tipoPessoa: prestador.tipoPessoa?.nome || "JURIDICA",
        },
      telefones: prestador.telefones?.map((telefone) => {
        return {
          tipo: telefone.tipo?.nome,
          numero: telefone.numero?.split(" ")[1],
          ddd: telefone.numero
            ?.split(" ")[0]
            .replace(/\(/, "")
            .replace(/\)/, ""),
          ramal: telefone.ramal,
        };
      }) as TelefonesDTO[],
      precosServico: prestador.precosServico?.map((servico) => {
        return {
          id: servico.id,
          kmSaida: servico.kmSaida,
          tipoServico: servico.tipoServico?.name,
          tipoVeiculo: servico.tipoVeiculo?.name,
          valorKmExcedido: servico.valorKmExcedido,
          estado: servico.estado?.sigla,
          cidade: servico.cidade,
          bairro: servico.bairro,
          valorSaida: servico.valorSaida,
          cep: servico.cep,
          latitude: servico.latitude,
          longitude: servico.longitude,
          raioDistancia: servico.raioDistancia,
          valorPatins: servico.valorPatins,
          valorHoraParado: servico.valorHoraParado,
          valorHoraTrabalhado: servico.valorHoraTrabalhado
        };
      }) as ServicosDTO[],
    };
    
    if (prestador.id) {
      return this.put(`/prestador/${prestador.id}`, prestadorDTO);
    } else {
      return this.post("/prestador", prestadorDTO);
    }
  }

  pesquisarPrestadorAssistencia(
    cpfCnpj: string,
    nome: string,
    tipoServico: string,
    tipoVeiculo: string,
    pagina: number,
    itensPorPagina: number,
    sortColumn: string,
    sortDirection: string,
    estado: string,
    cidade: string
  ): Promise<any> {
    return this.get("/prestador/filtro", {
      params: {
        cpfCnpj,
        nome,
        tipoServico,
        tipoVeiculo,
        estado,
        cidade,
        page: pagina,
        rowsPerpage: itensPorPagina,
        sortColumn,
        sortDirection
      },
    });
  }

  pesquisarAssociadoAssistencia(
    cpfCnpj: string,
    nome: string,
    pagina: number,
    itensPorPagina: number,
    sortColumn: string,
    sortDirection: string,
    estado: string,
    cidade: string
  ): Promise<any> {
    return  this.get("/associado/filtro", {
          params: {
            cpfCnpj,
            nome,
            estado,
            cidade,
            page: pagina,
            rowsPerpage: itensPorPagina,
            sortColumn,
            sortDirection
          },
        })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao lista de associados.");
      });
  }

  pesquisarPrestadorAssistenciaServicos(filtro: FiltroServicoDTO): Promise<ResultadoFiltroServicosDTO> {
    return this.post<FiltroServicoDTO>("/servico/prestadores", filtro)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao obter lista de serviços");
      });
  }

  pesquisarServicosAssistencia(filtro: FiltroServicoDTO): Promise<ResultadoFiltroServicosDTO> {
    return this.post<FiltroServicoDTO>("/servico/servicos", filtro)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao obter a nova lista de serviços");
      });
  }

  pesquisarServicosSemPrestador(filtro: FiltroServicoSemPrestadorDTO): Promise<ResultadoServicosSemPrestadorDTO> {
    return this.post<FiltroServicoSemPrestadorDTO>("/logs/servicos", filtro)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao obter lista de serviços");
      });
  }

  consultarServicosFrota(request: any): Promise<any> {
    return this.post<FiltroServicoSemPrestadorDTO>("/servico/frota/faturamento", request)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao obter lista de serviços do frota");
      });
  }

  consultarLeadFrota(request: any): Promise<any> {
    return this.post<FiltroServicoSemPrestadorDTO>("/frota/leads/consultar", request)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao obter lista de leads frota");
      });
  }

  consultarLeadFrotaId(id: Number): Promise<any> {
    return this.get(`/frota/leads/consultar/${id}`);
  }

  gerarRelatorioLeadsFrota(
    tipo: string,
    requestDTO: FiltroLeadFrotaDTO
  ): Promise<any> {
    return this.post<FiltroLeadFrotaDTO>(
      tipo.toLocaleLowerCase() === 'pdf' ? "/frota/leads/relatorio/pdf" : '/frota/leads/relatorio/xls',
      requestDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  imprimirFatura(filtroDTO: any): Promise<any> {
    return this.post<any>(
      "/servico/frota/fatura/pdf",
      filtroDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarFaturaServicosFrota(filtroDTO: any): Promise<any> {
    return this.post<any>(
      "/faturamento/frota/gerar-fatura",
      filtroDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }
  
  validarPagamentoFaturaServicosFrota(request: any): Promise<any> {
    return this.post<FiltroServicoSemPrestadorDTO>("/faturamento/frota/validar-fatura", request)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao gerar faturamento");
      });
  }

  gerarRelatorioServicosFrotaPDF(filtroDTO: any): Promise<any> {
    return this.post<any>(
      "/servico/frota/faturamento/pdf",
      filtroDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarRelatorioServicosFrotaXLS(filtroDTO: any): Promise<any> {
    return this.post<any>(
      "/servico/frota/faturamento/xls",
      filtroDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-xls",
        },
      }
    );
  }

  gerarRelatorioLogServicoSemPrestadorPDF(filtroDTO: any): Promise<any> {
    return this.post<any>(
      "/logs/servicos/pdf",
      filtroDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarRelatorioLogServicoSemPrestadorXLS(filtroDTO: any): Promise<any> {
    return this.post<any>(
      "/logs/servicos/xls",
      filtroDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-xls",
        },
      }
    );
  }
  
  deletePrestadorAssistencia(id: number): Promise<any> {
    return this.delete(`/prestador/${id}`);
  }

  obterPrestador(id: string): Promise<any> {
    return this.get(`/prestador/${id}`);
  }

  obterClienteFrota(id: string): Promise<any> {
    return this.get(`/frota/cliente/${id}`);
  }

  saveClienteFrota(cliente: ClienteFrotaModel): Promise<any> {
    let clienteDTO =_.assign({}, cliente, { 
      cpfCnpj: cliente.cpfCnpj?.replace(/\D/g,""),
      contato: _.assign({}, cliente.contato, { 
        ddd: cliente.contato.numero
            ?.split(" ")[0]
            .replace(/\(/, "")
            .replace(/\)/, ""),
        numero: cliente.contato.numero?.split(" ")[1].replace(/\D/g,""),
        cpf: cliente.contato.cpf?.replace(/\D/g,""),
      }),
      endereco: _.assign({}, cliente.endereco, { 
        tipo: cliente.endereco?.tipo?.nome,
        estado: cliente.endereco?.estado?.sigla,
        cep: cliente.endereco?.cep?.replace(/\D/g,""),
      }),
      telefones: _.map(cliente.telefones, (tel: any) => {
        return _.assign({}, tel, { 
          tipoResponsavel: tel.tipoResponsavel?.nome,
          tipo: tel.tipo?.nome,
          numero: tel.numero?.split(" ")[1],
          ddd: tel.numero
            ?.split(" ")[0]
            .replace(/\(/, "")
            .replace(/\)/, ""),
        });
      }),
      veiculos: _.map(cliente.veiculos, (vei: any) => {
        return _.assign({}, vei, { 
          tipoVeiculo: vei.tipoVeiculo?.name,
          estadoRegiaoFrota: vei.estadoRegiaoFrota?.sigla,
        });
      }),
    });

    if (cliente.id) {
      return this.put(`/frota/cliente/${cliente.id}`, clienteDTO);
    } else {
      return this.post("/frota/cliente", clienteDTO);
    }
  }

  saveAgente(agente: AgenteModel): Promise<any> {
    let agenteDTO: AgenteDTO = {
      cpfCnpj: agente.cpfCnpj?.replace(/\D/g,""),
      nome: agente.nome,
      segmento: {
        id: agente.segmento?.id,
        descricao: agente.segmento?.descricao
      },
      tipoPessoa: agente.tipoPessoaString == "F" ? "FISICA" : "JURIDICA",
      ativo: true,
      enderecos: agente.enderecos?.map((endereco) => {
        return {
          cep: endereco.cep,
          tipo: endereco.tipo?.nome,
          logradouro: endereco.logradouro,
          numero: endereco.numero,
          complemento: endereco.complemento,
          bairro: endereco.bairro,
          cidade: endereco.cidade,
          estado: endereco.estado
            ? estadosList
                .map((e) => e.sigla)
                .filter((ec) => ec == endereco.estado?.sigla)
                .toString()
            : "-1",
        };
      }) as EnderecosDTO[],
      contatos : agente.contatos?.map((contato) => {
        return {
          tipo: contato.tipo?.nome,
          numero: contato.numero?.split(" ")[1],
          ddd: contato.numero
            ?.split(" ")[0]
            .replace(/\(/, "")
            .replace(/\)/, ""),
          ramal: contato.ramal,
          email: contato.email,
        };
      }) as ContatosDTO[],
      contaBancaria: 
        {
          codigoBanco: agente.contaBancaria.codigoBanco,
          contaPrincipal: true,
          id: agente.contaBancaria.id,
          cpfCnpjTitular: agente.cpfCnpj?.replace(/\D/g,""),
          digitoConta: agente.contaBancaria.digitoConta,
          nomeTitular: agente.nome,
          numeroAgencia: agente.contaBancaria.numeroAgencia,
          numeroConta: agente.contaBancaria.numeroConta,
          digitoAgencia: agente.contaBancaria.digitoAgencia,
          tipoPessoa: agente.tipoPessoa?.nome || "JURIDICA",
        },
        comissionamentos: agente.comissionamentos?.map((comissionamento) => {
          return {
            tipoServico: comissionamento.tipoServico?.name,
            percentualComissao: comissionamento.percentualComissao,
            pessoaRepasse: comissionamento.pessoaRepasse?.id,
            percentualRepasse: comissionamento.percentualRepasse,
            agravo: comissionamento.agravo,
            desconto: comissionamento.desconto,
          };
        }) as ComissionamentosDTO[],
        informacoes: agente.informacoes?.map((informacao) => {
          return {
            registro: informacao.registro,
            usuario: informacao.usuario,
            dataCriacao: informacao.dataCriacao,
          };
        }) as InformacoesDTO[],
    }

    if (agente.id) {
      return this.put(`/agente/atualizar/${agente.id}`, agenteDTO);
    } else {
      return this.post("/agente/", agenteDTO);
    }
  }

  verificarCpfCnpj(cpfCnpj: string) {
    return this.get(`/prestador/cpf-cnpj?cpfCnpj=${cpfCnpj.replace(/\D/g, "")}`);
  }

  ativarPrestador(id: number): Promise<any> {
    return this.put(`/prestador/${id}/ativar`);
  }

  inativarPrestador(id: number): Promise<any> {
    console.log(`Inativando prestador ${id}`);
    return this.put(`/prestador/${id}/inativar`);
  }

  ativarFrota(id: number): Promise<any> {
    console.log(`Ativando associado para frota ${id}`);
    return this.put(`/associado/${id}/ativar`);
  }

  ativarCliente(id: number): Promise<any> {
    console.log(`Ativando associado ${id}`);
    return this.put(`/associado/cliente/${id}/ativar`);
  }

  inativarFrota(id: number): Promise<any> {
    console.log(`Inativando associado para frota ${id}`);
    return this.put(`/associado/${id}/inativar`);
  }

  inativarCliente(id: number): Promise<any> {
    console.log(`Inativando associado ${id}`);
    return this.put(`/associado/cliente/${id}/inativar`);
  }

  ativarFaturamento(id: number): Promise<any> {
    console.log(`Ativando associado ${id}`);
    return this.put(`/associado/cliente/${id}/faturamento/ativar`);
  }

  inativarFaturamento(id: number): Promise<any> {
    console.log(`Inativando faturamento para o associado ${id}`);
    return this.put(`/associado/cliente/${id}/faturamento/inativar`);
  }

  buscarServicosPrestador(
    filtro: FiltroServicoDTO
  ): Promise<ResultadoFiltroServicosDTO> {
    // console.log(filtro);
    return this.post<FiltroServicoDTO>("/servico/prestador", filtro)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao obter lista de serviços");
      });
  }

  obterQuantidadeServicos(
    filtro: any
  ): Promise<any> {
    return this.post<any>("/servico/administrativo/monitoramento", filtro)
      .then((registered: AxiosResponse) => {    
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao obter lista de serviços");
      });
  }

  obterServicoDetalhado(idServico: number): Promise<ServicoDetalhadoModel> {
    return this.get<number>(`/servico/administrador/${idServico}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter os detalhes do serviço");
      });
  }

  obterFotoVeiculo(idServico: number, nomeArquivo: string): Promise<any> {
    return this.get(`/servico/${idServico}/veiculo/fotos/${nomeArquivo}`, {
      responseType: "blob",
    })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter foto do veículo.");
      });
  }

  aceitarServico(aceitacaoServico: ServicoPrestadorDTO) {
  return this.post<ServicoPrestadorDTO>(
    "/servico/administrador/aceitarServico",
    aceitacaoServico
  )
    .then((registered: AxiosResponse) => {
      const { data } = registered;
      return data;
    })
    .catch((error: AxiosError) => {
      let mensagem = "Ocorreu um erro ao efetuar o aceite do serviço.";
      if (error.response?.data.detail) {
        if(error.response?.data.detail.match(/Prazo de ACEITE/)){
          mensagem = error.response?.data.detail
        } 
      }
      throw new Error(mensagem);
    });
}

reenviarServico(aceitacaoServico: ServicoPrestadorDTO) {
  return this.post<ServicoPrestadorDTO>(
    "/servico/administrador/reenviarServico",
    aceitacaoServico
  )
    .then((registered: AxiosResponse) => {
      const { data } = registered;
      return data;
    })
    .catch((error: AxiosError) => {
      throw new Error("Falha ao obter lista de serviços");
    });
}

recusarServico(aceitacaoServico: ServicoPrestadorDTO) {
  return this.post<ServicoPrestadorDTO>(
    "/servico/administrador/recusar",
    aceitacaoServico
  )
    .then((registered: AxiosResponse) => {
      const { data } = registered;
      return data;
    })
    .catch((error: AxiosError) => {
      throw new Error("Falha ao obter lista de serviços");
    });
  }

  finalizarServico(finalizarServico: FinalizarSolicitacaoModel) {
    return this.post<FinalizarSolicitacaoModel>(
      "/servico/administrador/finalizar",
      finalizarServico
    )
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter os detalhes do serviço");
      });
  }

  obterValorPercentual(id: string): Promise<PercentualServicoDTO> {
    return this.get<PercentualServicoDTO>(`servico/valor-percentual/${id}`)
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  salvarValorPercentual(configuracao: PercentualServicoDTO): Promise<PercentualServicoDTO> {
    console.log(configuracao);
    return this.put<PercentualServicoDTO>(`servico/valor-percentual`, configuracao)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao salvar percentual");
      });
  }

  obterBancos(): Promise<BancoDTO[]> {
    return this.get(`prestador/bancos`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }
  
  obterPrestadorPorPlaca(placa : string): Promise<{}> {

    let config = {
      returnRejectedPromiseOnError: true,
      withCredentials: true,
      timeout: 20000,
      baseURL: process.env.VUE_APP_LOCALIZACOES_API,
      headers: {
        common: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          "Content-Type": "application/json",
          Accept: "application/json, text/plain",
        },
      },
    }

    return this.get(`localizacao/localizar?placa=${placa}`, config)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao buscar prestador pela placa");
      });
  }

  obterPrestadorPorServico(idServico: number): Promise<{}> {

    let config = {
      returnRejectedPromiseOnError: true,
      withCredentials: true,
      timeout: 20000,
      baseURL: process.env.VUE_APP_LOCALIZACOES_API,
      headers: {
        common: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          "Content-Type": "application/json",
          Accept: "application/json, text/plain",
        },
      },
    }

    return this.get(`localizacao/localizar/servico?servico=${idServico}`, config)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao buscar servico");
      });
  }

  obterPrestadoresNaRegiao(request : any): Promise<{}> {
    console.log(request);

    return this.post<any>(`servico/administrativo/buscar-prestadores`, request)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao obterPrestadoresNaRegiao");
      });
  }

  obterPrecosServicos(id: number): Promise<PrecosServicoModel[]> {
    return this.get(`servico/administrador/preco/${id}`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  salvarBancos(configuracao: BancoDTO): Promise<BancoDTO> {
    console.log(configuracao);
    return this.post<BancoDTO>(`prestador/banco`, configuracao)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao salvar banco");
      });
  }

  atualizarBancos(configuracao: BancoDTO): Promise<BancoDTO> {
    console.log(configuracao);
    return this.put<BancoDTO>(`prestador/banco`, configuracao)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao atualizar banco");
      });
  }

  excluirBanco(id: String) {
    return this.delete(`prestador/banco/${id}`).catch(() => {
      throw new Error("Falha ao excluir banco.");
    });
  }

  obterConfiguracao(): Promise<PercentualServicoDTO[]> {
    return this.get(`servico/configuracao/`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  salvarConfiguracao(configuracao: PercentualServicoDTO): Promise<PercentualServicoDTO> {
    console.log(configuracao);
    return this.put<PercentualServicoDTO>(`servico/configuracao/`, configuracao)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao salvar configurações.");
      });
  }

  obterSegmento(): Promise<SegmentoDTO[]> {
    return this.get(`segmento/`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  salvarSegmento(crud: SegmentoDTO): Promise<SegmentoDTO> {
    if (crud.id > 0) {
      return this.put<SegmentoDTO>(`segmento/${crud.id}`, crud)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao salvar segmento.");
      });
    }

    return this.post<SegmentoDTO>(`segmento`, crud)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.error(error);
        throw new Error("Falha ao salvar segmento.");
      });    
  }

  excluirSegmento(id: number) {
    return this.delete(`segmento/${id}`).catch(() => {
      throw new Error("Falha ao excluir segmento.");
    });
  }


  obterFaixaPercentual(): Promise<FaixaPercentualDTO[]> {
    return this.get(`servico/administrativo/faixa-percentual/`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter faixa de preço.");
      });
  }

  excluirFaixaPercentual(id: number) {
    return this.delete(`servico/administrativo/faixa-percentual/${id}`).catch(() => {
      throw new Error("Falha ao excluir a faixa de preço.");
    });
  }

  salvarFaixaPercentual(faixaPercentualDTO:FaixaPercentualDTO): Promise<any> {
    return this.post(`servico/administrativo/faixa-percentual`, faixaPercentualDTO)
    .catch((error: AxiosError) => {
      const data = error.response?.data;
        if (data.status == 400) {
          throw new Error(data.detail);
        } else {
          throw new Error("Falha ao salvar faixa de preço.");
        }
    });
  }
  
  filtrarLogPrecificacao(filtroDTO: any) {
    return this.post<LogPrecificacaoModel>(
      "/logs/recuperar",
      filtroDTO,
    );
  }

  gerarRelatorioLogPrecificacao(filtroDTO: any): Promise<any> {
    return this.post<any>(
      "/logs/relatorio/pdf",
      filtroDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarRelatorioLogPrecificacaoXls(filtroDTO: any): Promise<any> {
    return this.post<any>(
      "/logs/relatorio/xls",
      filtroDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-xls",
        },
      }
    );
  }

  obterTermoDeUso(): Promise<TermoDeUsoDTO[]> {
    return this.get(`prestador/termo-de-uso`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  downloadTermoDeUso(nomeArquivo:String): Promise<any> {
    return this.get(`prestador/termo-de-uso/download/${nomeArquivo}`, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      }})
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  uploadTermoDeUso(file: File) {
    let formData = new FormData();
    formData.append("arquivo", file);
    let config = {
      returnRejectedPromiseOnError: true,
      withCredentials: true,
      timeout: 10000,
      baseURL: process.env.VUE_APP_ASSISTENCIA_24H_API,
      headers: {
        common: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      },
    }

    return this.post("prestador/termo-de-uso", formData, config)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao efetuar upload da foto");
      });
  }

  filtrarAgentes(filtroDTO: FiltroAgenteModel) {
    return this.post<FiltroAgenteModel>(
      "/agente/consultar",
      filtroDTO,
    );
  }

  ativarAgente(id: number): Promise<any> {
    console.log(`Ativando associado ${id}`);
    return this.put(`/agente/${id}/ativar`);
  }

  inativarAgente(id: number): Promise<any> {
    console.log(`Inativando associado ${id}`);
    return this.put(`/agente/${id}/inativar`);
  }

  excluirAgente(id: number) {
    return this.delete(`agente/${id}`).catch(() => {
      throw new Error("Falha ao excluir agente.");
    });
  }

  verificarCpfCnpjAgente(cpfCnpj: string) {
    return this.get(`/agente/cpf-cnpj?cpfCnpj=${cpfCnpj.replace(/\D/g, "")}`);
  }

  listarAgentes(): Promise<any> {
    return this.get(`/agente/listar/agentes`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  agentes(): Promise<any> {
    return this.get(`/agente/listar`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  obterAgente(id: string): Promise<any> {
    return this.get(`/agente/${id}`);
  }
  
  solicitarPrecificacao(
    solicitacaoServicoDTO: SolicitacaoServicoDTO
  ): Promise<string> {
    return this.post<SolicitacaoServicoDTO>(
      "/servico/administrativo/solicitarPrecificacao",
      solicitacaoServicoDTO
    ).then((registered: AxiosResponse) => {
      const { data } = registered;
      return data;
    })
    .catch((error: AxiosError) => {
      if(error.response?.data.status == 404 && error.response?.data.error != "Not Found") {
        if(error.response?.data.detail) {
          throw new Error(error.response?.data.detail);
        }
        throw new Error("Não foi possível efetuar a precificação do serviço para a região.");
      }

      if(error.response?.data.status == 400 && error.response?.data?.detail?.includes('KM')) {
        throw new Error(error.response?.data.detail);
      }  
      
      throw new Error("Falha ao calcular preço do servico");
    });
  }

  confirmarSolicitacao(
    confirmacaoSolicitacaoDTO: ConfirmacaoSolicitacaoDTO
  ): Promise<string> {
    return this.post<ConfirmacaoSolicitacaoDTO, AxiosResponse<string>>(
      "/servico/administrativo/confirmarServico",
      confirmacaoSolicitacaoDTO
    )
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        if (!error.response?.data.isAutorizado) {
          throw new Error(error.response?.data.message);
        } else {
          throw new Error("Falha ao confirmar solicitação do servico");
        }
      });
  }

  efetuarUploadFoto(file: File) {
    var formData = new FormData();
    formData.append("arquivo", file);
    var config = {
      returnRejectedPromiseOnError: true,
      withCredentials: true,
      timeout: 10000,
      baseURL: process.env.VUE_APP_ASSISTENCIA_24H_API,
      headers: {
        common: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      },
    }


    return this.post("/servico/veiculo/foto", formData, config)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao efetuar upload da foto");
      });
  }

  confirmarSolicitacaoFrota(
    confirmacaoSolicitacaoDTO: ConfirmacaoSolicitacaoFrotaDTO
  ): Promise<string> {
    return this.post<ConfirmacaoSolicitacaoFrotaDTO, AxiosResponse<string>>(
      "/servico/administrativo/frota/confirmarServico",
      confirmacaoSolicitacaoDTO
    )
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        if (!error.response?.data.isAutorizado) {
          throw new Error(error.response?.data.message);
        } else {
          throw new Error("Falha ao confirmar solicitação do servico");
        }
      });
  }

  confirmarSolicitacaoAdm(
    confirmacaoSolicitacaoDTO: ConfirmacaoSolicitacaoFrotaDTO
  ): Promise<string> {
    return this.post<ConfirmacaoSolicitacaoFrotaDTO, AxiosResponse<string>>(
      "/servico/administrativo/confirmarServico",
      confirmacaoSolicitacaoDTO
    )
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        if (!error.response?.data.isAutorizado) {
          throw new Error(error.response?.data.message);
        } else {
          throw new Error("Falha ao confirmar solicitação do servico");
        }
      });
  }

  recalcularValorServico(
    confirmacaoSolicitacaoDTO: ConfirmacaoSolicitacaoFrotaDTO
  ): Promise<string> {
    return this.post<ConfirmacaoSolicitacaoFrotaDTO, AxiosResponse<string>>(
      "/servico/administrativo/valor-servico",
      confirmacaoSolicitacaoDTO
    )
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        if (!error.response?.data.isAutorizado) {
          throw new Error(error.response?.data.message);
        } else {
          throw new Error("Falha ao recalcular valor deo serviço");
        }
      });
  }

 

  pesquisarClienteAdministrativoCpfCnpj(filtro: string): Promise<any> {
     return this.get(`/associado/administrativo/listar-cpfCnpj-por/${filtro}`);
  }

  pesquisarClienteAdministrativoNome(filtro: string): Promise<any> {
    return this.get(`/associado/administrativo/listar-nome-por/${filtro}`);
 }

  administrativoCancelar(servico: any): Promise<any> {
    return this.post<any>("/servico/administrativo/cancelar", servico)
    .catch((error: AxiosError) => {
      if (!error.response?.data.isAutorizado) {
        throw new Error(error.response?.data.message);
      } else {
        throw new Error("Falha ao cancelar serviço");
      }
    });
  }

    pesquisarPrestadorComplemento(filtro: any): Promise<any> {
    return this.post<any>("/servico/administrativo/prestador/complemento", filtro)
    .catch((error: AxiosError) => {
      if (!error.response?.data.isAutorizado) {
        throw new Error(error.response?.data.message);
      } else {
        throw new Error("Falha ao buscar prestadores");
      }
    });
  }

}

export const assistencia24hApiNew = new Assistencia24hApi(
  assistencia24hApiConfig
);
